import {Carrier} from "@shared/models/carrier";
import {DateTime} from "luxon";

export enum TrailerStatus {
    Planned = 1,
    ArrivedInbound = 2,
    Empty = 3,
    LoadedOutbound = 4,
    Left = 5
}

export interface Trailer {

    id: number;

    siteId: string;

    siteSubinventoryId: number;

    carrierId: number;

    carrier?: Carrier;

    outboundLoadId: number;
    inboundLoadId: number;

    trailerNumber: string;

    trailerStatus: TrailerStatus;

    arrivedAt: DateTime | null;
    unloadedAt: DateTime | null;
    loadedAt: DateTime | null;
    departedAt: DateTime | null;
}

export interface TrailerChecklistCheck {
    trailerId: number;
    workShiftId: number;
    checked: boolean;
    lastChangedBy: string;
    lastChanged: DateTime;
}

export interface CreatedTrailer {
    siteId: string;
    siteSubinventoryId: number;
    carrierId: number;
    trailerNumber: string;

    arrivedAt: DateTime | null;
}
